import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-ivory px-4 sm:px-6 py-9 sm:py-12" data-id="element-206" data-mp="3kqw3yjl330fl">
      <div className="max-w-3xl mx-auto" data-id="element-207" data-mp="3fyvy6aic1db3">
        <h2 className="font-heading font-extrabold uppercase text-lg sm:text-2xl leading-tight tracking-tight text-petrol text-center mb-1.5" data-id="element-208" data-mp="3fxunw8954uuf">
          What senior fitness coaches say
        </h2>
        <p className="text-center font-heading font-semibold text-[10px] sm:text-xs uppercase tracking-[0.14em] text-green-dark mb-6" data-id="element-209" data-mp="370akotrpwoh6">
          Verified professional reviews
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-2.5" data-id="element-210" data-mp="2x1bj1v5ddt3o">
          {testimonials.map((t, i) => <figure key={t.author} className={`bg-white border border-petrol/10 rounded-lg p-4 flex flex-col shadow-sm ${i === 0 ? 'lg:col-span-2' : ''}`} data-id="element-211" data-mp="2s3jhe9exasma" data-mpi={i}>
              <div className="flex gap-0.5 mb-2" aria-label="5 out of 5 stars" data-id="element-212" data-mp="qb511es11w7z">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-3 h-3 fill-gold text-gold" data-id="element-213" data-mp="m51cjvsy5da0" data-mpi={j} />)}
              </div>

              <blockquote className="text-[12px] sm:text-sm text-petrol/80 leading-relaxed mb-3" data-id="element-214" data-mp="78abli3mjtia">
                "{t.text}"
              </blockquote>

              <figcaption className="flex items-center gap-2.5 mt-auto pt-2.5 border-t border-petrol/10" data-id="element-215" data-mp="c73p3aiwvkig">
                <div className="w-8 h-8 rounded-full bg-petrol flex items-center justify-center font-heading font-bold text-white text-[11px] shrink-0" data-id="element-216" data-mp="zyiwhhpjos0k">
                  {t.author.charAt(0)}
                </div>
                <div className="leading-tight" data-id="element-217" data-mp="q4s96g55mnmg">
                  <p className="font-heading font-bold text-[12px] text-petrol" data-id="element-218" data-mp="v4o65vffpesi">
                    {t.author}
                  </p>
                  <p className="text-[9px] font-semibold uppercase tracking-wide text-petrol/50 mt-0.5" data-id="element-219" data-mp="1it7bq373ndgw">
                    {t.role} — {t.location}
                  </p>
                </div>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}